import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div id={{this.id}} {{this.handleInsert}}></div>\n",{ moduleName: "uplisting-frontend/components/widgets/zapier/index.hbs" })